module.exports = __webpack_public_path__ + "img/confetis.a083d900.svg";